import { apiService, createRequestHeadersConfig } from 'shared/api'

const api = apiService()

export enum BannersAudience {
  authorized = 'logged_in',
  notAuthorized = 'guests',
  everyone = 'everyone'
}

export interface BannerTypes {
  id: string
  webImage: string
  mobileImage: string
  placement: string
  ageLimit: number
  section: string
  side: string
  sort_order: number
  destinationUrl: string
  title: string
  name: string
  subtitle: string
  description: string
  createdAt: string
  updatedAt: string
  ageLimitMet: boolean
  productCategoryId?: string
  targetAudience: BannersAudience
}

export interface BannersData {
  mainPage: BannerTypes[] | []
  listing: BannerTypes[] | []
  search: BannerTypes[] | []
}

interface FetchBannersResponse {
  data: BannersData
}
interface EmptyFetchBannersResponse {
  data: []
}

export const fetchBanners = (payload: { token?: string }) => {
  return api.get<FetchBannersResponse | EmptyFetchBannersResponse>(
    `/banners`,
    createRequestHeadersConfig(payload?.token)
  )
}

export const fetchBannersQuery = async (token: string | undefined) => {
  const response = await fetchBanners({ token })

  if (Array.isArray(response.data.data)) {
    return {
      mainPage: response.data.data,
      listing: [],
      search: []
    }
  }

  return response.data.data
}

export const trackBannerClick = async (bannerId: string): Promise<void> => {
  await api.patch(`banners/${bannerId}/add-click`, {})
}
